<header class="account-contact-header">
  <h3 class="account-contact-title">{{ 'contact_data' | translate }}</h3>
  <p class="account-contact-subtitle ods-typography-body-s-regular">{{ 'contact_data_text' | translate }}</p>
</header>
<main class="account-contact-body">
  <mat-form-field class="account-contact-field">
    <mat-label>{{ 'mobile_' | translate }}</mat-label>
    <input matInput autocomplete="off" name="contactPhone" (keydown.enter)="onSubmit()" [formControl]="mobileControl" />
    <mat-error *ngIf="mobileControl.errors?.required || mobileControl.errors?.invalid"
      >{{ 'mobile_number_is_invalid' | translate }}
    </mat-error>
  </mat-form-field>
  <mat-expansion-panel *ngIf="mobilePhones?.length > 1" class="account-contact-phones-expansion-panel">
    <mat-expansion-panel-header>
      <span class="account-contact-phones-expansion-panel-header"
        >{{ 'we_found' | translate }} {{mobilePhones?.length}} {{ 'mobile_numbers_included_in_your_cosmote_id' |
        translate }}</span
      >
    </mat-expansion-panel-header>
    <mat-radio-group class="account-contact-phones-expansion-panel-radio-group" (change)="onPhoneSelect($event.value)">
      @for (phone of mobilePhones; track phone) {
      <mat-radio-button
        color="primary"
        [value]="phone"
        [checked]="verifiedMSISDN === phone"
        (change)="selectPhone(mobilePhones, phone)"
      >
        <span class="account-contact-phones-expansion-panel-phone">{{ phone }}</span>
      </mat-radio-button>
      }
    </mat-radio-group>
  </mat-expansion-panel>
  <button
    box-button
    theme="primary"
    class="account-contact-button"
    [disabled]="mobileControl.invalid"
    (click)="onSubmit()"
    [attr.aria-label]="'save_' | translate"
  >
    {{ 'save_' | translate }}
  </button>
</main>
